// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__atwXN","head":"Table_head__okG3A","col":"Table_col__1ll_P"};